module.exports = __webpack_public_path__ + "static/img/about_1.b07c28b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_1.jpg
// module id = RHrI
// module chunks = 1